import { memo } from 'react';
import styled from 'styled-components';
import { ButtonRounded } from '@comeon/ui';

const ButtonOutlined = memo(styled(ButtonRounded)`
	background-color: transparent;
	font: var(--label-bold);
	border: 1px solid var(--button-outlined-border-color, rgba(var(--primary), 1));
	color: var(--button-outlined-text-color, rgba(var(--primary), 1));
	padding: 10px 14px;
`);

export default ButtonOutlined;
